import React, { useState, useEffect } from "react";
import { Form, Table, Image, Col } from "react-bootstrap";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import { Menu, IconButton } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { Container, Row } from "react-bootstrap";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { HomeReusableButton } from "../../../superAdminComponents/superAdminReusable/superAdminHomeButton/HomeReusableButton";
import HomeReusableTopBarNavigation from "../../../superAdminComponents/superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import Media from "react-media";
import Pagination from "rc-pagination";
import { RightSideCountTop } from "../../OrderReports/RightSideCountTop";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { Exp_vendor_report } from "../../../../store/actions/SuperAdminReports/SuperAdminReports";
import isEmpty from "../../../../store/validation/is-Empty";
import { SmallLoader } from "../../../Loader/SmallLoader";
import { NEW_PAYMENT_TYPE, ORDER_STATUS, ORDER_TYPE, PAYMENT_STATUS, PAYMENT_TYPE } from "../../../../enums/OrderEnums";
import moment from "moment";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import BasicPagination from "../../../Pagination/Pagination";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { PAYMENT_METHOD_TYPE } from "../../../../store/types";
// import hi from '../../../../components/'
function ExpVendorReport(props) {

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [dateQuery, setDateQuery] = useState({
    // startDate: moment().format("YYYY-MM-DD"),
    // endDate: moment().format("YYYY-MM-DD"),
  });
  const [state, setState] = useState({
    search: "",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [restaurantReverse, setRestaurantReverse] = useState("");
  const [itemData, setitemData] = useState([]);
  const [type, setType] = useState('CURATED');

  let vendor_id = props?.match?.params?.id;
  let data = props?.location?.state?.data;

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  }

  const onSearchChange = (e) => {

    setState({
      ...state,
      [e.target.name]: e.target.value,
    });

  };

  const getData = () => {
    // props.All_Order_Reports(props.auth.user.accessToken,dateQuery);
    props.Exp_vendor_report(props.auth.user.accessToken, vendor_id, type, dateQuery);
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);

  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value) => (e) => {
    setRestaurantReverse(value);
    handleClose();
  };

  const [showSearch, setShowSearch] = useState(false);

  useEffect((async) => {
    if (!isEmpty(dateQuery)) {
      getData(props.auth.user.accessToken, dateQuery);
    }
  }, [dateQuery, type]);

  let tempdata = [];
  if (restaurantReverse === "A-Z") {
    tempdata = props?.get_exp_vendor && props?.get_exp_vendor.sort((a, b) => {

      if (a.userDetails !== null && b.userDetails !== null) {
        if (a.userDetails?.name < b.userDetails?.name) return -1;
        if (a.userDetails?.name > b.userDetails?.name) return 1;
        return 0;
      }
    });
  } else if (restaurantReverse === "Z-A") {
    tempdata = props?.get_exp_vendor && props?.get_exp_vendor?.sort((a, b) => {

      if (a.userDetails !== null && b.userDetails !== null) {
        if (a.userDetails?.name < b.userDetails?.name) return 1;
        if (a.userDetails?.name > b.userDetails?.name) return -1;
        return 0;
      }
    });
  }


  tempdata = props?.get_exp_vendor && props?.get_exp_vendor?.filter((item) => {
    return (
      item?.userDetails?.name?.toLowerCase().includes(state.search.toLowerCase()) ||
      item?.experienceId?.name.toLowerCase().includes(state.search.toLowerCase()) ||
      item?.experienceId?.expId.toLowerCase().includes(state.search.toLowerCase())
    )
  });

  const RenderTableBody = (item) => <TableBody item={item} />

  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Back" link={`/superadmin/experiencesummaryreports`} backIcon />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Experience Merchant Report
                </div>
                <div>
                  <div
                    align="right"
                    style={{ color: "#9E9E9E" }}
                    className="f10-400 my-2"
                  >
                    Report Run Date: {moment().format("Do MMM, YYYY")}
                  </div>
                  <div className="d-flex">
                    <div className="f12-400" style={{ color: "#9E9E9E" }}>Report Range Date :</div>
                    <div className="f12-500 ml-2">
                      {" "}
                      {moment(dateQuery?.startDate).format("ll")} -{" "}
                      {moment(dateQuery?.endDate).format("ll")}
                    </div>
                  </div>
                </div>

              </div>
              <Row>
                <Col xs={3} md={1} className="justify-content-end align-items-end">
                  <div className="enIMG75">
                    <Image
                      src={data?.logo_url}
                      alt="View"
                      title="View"
                      fluid
                      className="w-100 h-100"
                    />
                  </div>
                </Col>
                <Col xs={8} md={4} style={{ paddingLeft: '50px' }}>
                  <div className="f24-500 my-2 ">
                    {data?.restaurant_name}
                  </div>
                  <div className="f14-400">
                    {data?.restaurant_address}
                  </div>
                </Col>
              </Row><br />
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="d-flex align-items-center justify-content-between">
                    <Image
                      onClick={() =>
                        // this.setState({ showSearch: !this.state.showSearch })
                        setShowSearch(!showSearch)
                      }
                      alt="Search"
                      title="Search"
                      width="80px"
                      src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                    />
                    <Image
                      // onClick={handleClick}
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      src={require("../../../../assets/images/iconButton/sortbtn.svg")}
                      width="80px"
                    />
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      {/* {userFilter.map((ele, index) => {
                        return (
                          <MenuItem
                            value={ele.title}
                            key={index}
                            onClick={() => setSort(ele.title)}
                            disabled={ele.disabled}
                          >
                            {ele.title}
                          </MenuItem>
                        );
                      })} */}
                    </Menu>
                    <Image
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                      alt="Filter Icon"
                      onClick={() => {
                        // setshowFilter(!showFilter);
                      }}
                    />
                    {/* <CSVDownloader
                        filename={"settlement"}
                        headers={downloadData.headers}
                        data={downloadData.data}
                      /> */}
                  </div>
                </div>
                <div>
                  <SelectFilter onDateChange={onDateChangeHandler()} />
                </div>
              </div>
              {showSearch && (
                <>
                  <div className="filter-button-search">
                    <Paper component="form" className="enSearch2 d-flex">
                      <IconButton type="submit" aria-label="search">
                        <SearchIcon />
                      </IconButton>
                      <InputBase
                        placeholder="Search"
                        name="search"
                        inputProps={{
                          "aria-label": "Search by Name or Phone Number",
                        }}
                        onChange={onSearchChange}
                        value={state.search}
                      />
                    </Paper>
                  </div>
                </>
              )}
              <hr />
              <div className="d-flex justify-content-end align-items-center pt-4 pb-3">
                <RightSideCountTop
                  content={[
                    {
                      name: "Total No. of Attendees",
                      value: props?.stats?.attendees || 0,
                      backgroundColor: "#FFEDE9",
                      color: "#EE3A23",
                    },
                    {
                      name: "Total Amount",
                      value: props?.stats?.amount || 0,
                      backgroundColor: "#D8F3F4",
                      color: "#138B90",
                    },
                  ]}
                />
              </div>
              <div className="d-flex justify-content-between">
                <div className="w-50">
                  <div className="d-flex">
                    <div
                      className={`mr-3 ${type === "CURATED" && `selected-global-catalogue `
                        } f14-500`}
                      onClick={() => setType("CURATED")}
                      style={{ cursor: "pointer" }}
                    >
                      Occasions
                    </div>
                    <div
                      className={`ml-3 ${type === "SPECIAL" && `selected-global-catalogue `
                        } f14-500`}
                      onClick={() => setType('SPECIAL')}
                      style={{ cursor: "pointer" }}
                    >
                      Events
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="enMinWidth900">
                    <thead style={{ fontSize: '10px' }}>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "200px" }} className="table-style f12-500">My Experience/<br /> Experience ID</th>
                        {/* <th style={{ width: "150px" }} className="table-style f12-500"><center>Business</center></th> */}
                        <th style={{ width: "180px" }} className="table-style f12-500">User</th>

                        <th style={{ width: "150px" }} className="table-style f12-500">Category</th>
                        <th style={{ width: "150px" }} className="table-style f12-500">Sub Category</th>
                        <th style={{ width: "150px" }} className="table-style f12-500">Total PAX / <br />Experience Ticket No</th>
                        <th style={{ width: "150px" }} className="table-style f12-500">Table/ <br />Seat No</th>
                        <th style={{ width: "150px" }} className="table-style f12-500">Experience <br /> Status</th>
                        <th style={{ width: "150px" }} className="table-style f12-500">Ticket Total<br /> Amount</th>
                      </tr>
                    </thead>
                    {/* {console.log(props.get_exp_vendor?)} */}
                    {props?.auth.secondary_loader ? <SmallLoader /> : !isEmpty(tempdata) && (tempdata?.slice(start, end).map((item, index) =>
                      RenderTableBody(item)
                    ))}
                  </Table>
                </div>
              </div>

              <div className="p4v2-menu-pagination">
                <BasicPagination
                  totalRecords={props?.get_exp_vendor?.length}
                  limit={5}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              </div>
            </div>
          </div>
          {/* <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media> */}
        </div>

      </div>
    </React.Fragment>
  );
}


const TableBody = ({ item }) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = async () => {
    setTrDetail(!TrDetail);
  };

  const paymentStatus = ['Pending', 'Completed', 'Cancelled', 'Failed'];


  let transaction = item.transactionDetails.findLastIndex(e => e.paid);

  transaction = item.transactionDetails[transaction];

  return (
    <tbody className="w-100 seating-dashboard-body-new">
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css" key={item._id}>
              <tr className="super_admin_all_users_table_body" onClick={showTr}>
                <td style={{ width: "200px" }}>
                  <div className="f12-500">
                    {item?.experienceId.name}
                  </div>
                  <div className="f11-400">
                    {item?.experienceId?.expId}
                  </div>
                </td>
                <td style={{ width: "180px" }}>
                  <div className="f12-500">{item?.userDetails?.name}</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">{item?.experienceId?.category?.title || ""}</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">{item?.experienceId?.subCategory?.title || ""}</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">{parseInt(item?.adultCount) + parseInt(item?.kidsCount) + item?.package.adults + item.package.kids} PAX/</div>
                  <div className="f11-400">{item?.requestId}</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">{item?.tableNumber || 'N/A'}</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">{item?.status}</div>
                  <div className="f11-400">{moment(item?.expCompletionTime).format('LL')}</div>
                  <div className="f11-400">{moment(item?.expCompletionTime).format('LT')}</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ {item?.paymentData && item?.paymentData?.totalAmount}</div>
                </td>
              </tr>
              {TrDetail && (
                <>
                  <tr className="sd_accordion_body align-items-start">
                    <td style={{ width: "150px" }}>
                      <div className="f9-500 mb-2">Taxes</div>
                      <div className="f12-400">{0}</div>
                    </td>
                    <td style={{ width: "150px" }}>
                      <div className="f9-500 mb-2">Convenience<br /> Charge</div>
                      <div className="f12-400">{0}</div>
                    </td>
                    <td style={{ width: "150px" }}>
                      <div className="f14-500 py-2">Donation</div>
                      <div className="f12-400">{item?.paymentData?.donationAmount}</div>
                    </td>
                    <td style={{ width: "150px" }}>
                      <div className="f14-500 py-2">Payment Status <br /> Date & Time</div>
                      <div className="f12-500">{paymentStatus[item?.paymentStatus]}</div>
                      <div className="f10-400">{moment(transaction?.date).format('lll')}</div>
                    </td>
                    <td style={{ width: "150px" }}>
                      <div className="f14-500 py-2">Payment Method <br /> Transaction ID</div>
                      <div className="f12-500">{NEW_PAYMENT_TYPE[transaction?.paymentType]}</div>
                      <div className="f10-400">#{transaction?.txnId}</div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  )
};


ExpVendorReport.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  get_exp_vendor: state.reports.admin_exp_vendor?.expReq || [],
  stats: state.reports.admin_exp_vendor?.stats || {},
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  Exp_vendor_report,
})(ExpVendorReport);

// export default ExpVendorReport;
